import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NavigationState {
  isRadioPlaying: boolean
  isRadioBusy: boolean
}

const commonInitialState: NavigationState = {
  isRadioPlaying: false,
  isRadioBusy: false,
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: commonInitialState,
  reducers: {
    setRadioPlaying(state, action: PayloadAction<boolean>) {
      state.isRadioPlaying = action.payload
    },

    setIsRadioBusy(state, action: PayloadAction<boolean>) {
      state.isRadioBusy = action.payload
    },
  },
})

export const { setRadioPlaying, setIsRadioBusy } = navigationSlice.actions

export default navigationSlice.reducer
